"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationDocDownload',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        publish: '发布',
        unpublish: '下架',
        download: '下载'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationDocDownloadListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('文档标题', '新增文档').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationDocDownloadSaveApi)({
          title: value || 'E2E合同模板',
          category: '合同模板',
          fileUrl: 'https://example.com/templates/contract.pdf',
          fileName: 'contract.pdf'
        }).then(function () {
          _this2.$message.success('已保存');
          _this2.reload();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      (0, _decoration.decorationDocDownloadActionApi)(row.doc.id, {
        action: action
      }).then(function () {
        _this3.$message.success('已更新');
        _this3.reload();
      });
    }
  }
};